import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import SwalServices from '../../../services/swalServices/SwalServices';
import { PurchaseInquiryOutwardPopup } from './PurchaseInquiryOutwardTable';
import moment from 'moment';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class PurchaseInquiryOutward extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            permissions: { isAddEdit: false, isDelete: false, isView: false },
            globalUserID: '',
            usp_Users: [],
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            isSelectItemPopUp: false,
            isSelectInquiryPopUp: false,
            itemMasterList: [],
            inquiryList: [],
            rowData: [],
            colDefs: [],
            table2Data: [],
            table2ColDefs: [],
            itemRowData: [],
            activeMainTab: 'outward',
            itemsOverviewColDefs: [
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemType",
                    headerName: "Item Type",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "totalPurchaseInquiry",
                    headerName: "Total Purchase Inquiry",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "availableQty",
                    headerName: "Pending Qty",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            inquiryObject: {
                idPurchaseInquiryOutward: 0,
                updateStatus: 0,
                inquiryOutwardNo: '',
                inquiryOutwardDate: '',
                idEmployee: 0,
                idItem: 0,
                itemName: '',
                availableQty: 0,
                isApprove: false,
                remarks: '',
                prefix: '',
            },
            itemObject: {
                keyId: 0,
                drawingNo: '',
                idType: 1,
                TypeList: [
                    { value: 1, label: "RAW MATERIAL" },
                    { value: 2, label: "FINISHED GOODS" },
                    { value: 3, label: "SEMI FINISHED" },
                ],
                idItem: 0,
                itemName: '',
                quantity: '',
                remarks: '',
                idPurchaseInquiry: 0,
                idPurchaseInquiryItems: 0,
                materialType: '',
                pendingQty: 0,
                inquiryNo: '',
            },
            selectItemColDefs: [
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemType",
                    headerName: "Item Type",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "availableQty",
                    headerName: "Available Qty",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            selectInquiryColDefs: [
                {
                    field: "inquiryNo",
                    headerName: "Inquiry No",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "pendingQty",
                    headerName: "Pending Qty",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            validState: { isValid: true, error: {} },
            validationRulesForPurchase: {
                idItem: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "item"),
                    },
                ],
            },
            validationRulesForItem: {
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "quantity"),
                    },
                ],
            },
        }
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.usp_GetAllUsers();
                this.getItemListForOutward();
            });
        }
    }

    usp_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({ usp_Users: data });
                }
            }
        });
    }

    getItemListForOutward = () => {
        this.transactionStockServices.usp_Master_ItemSelect_ForPurchaseInquiryOutward(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                this.setState({ itemMasterList: response.responseItem.responseContent });
            }
        });
    }

    getInquiriesByItem = () => {
        let request = [this.state.idCompany, this.state.inquiryObject.idItem];
        this.transactionStockServices.usp_Transaction_PurchaseInquirySelect_ForOutward_ByItem(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                // Hide inquiries already added to the grid (unique by idPurchaseInquiryItems)
                let addedIds = this.state.itemRowData.map(x => x.idPurchaseInquiryItems);
                data = data.filter(x => !addedIds.includes(x.idPurchaseInquiryItems));
                this.setState({ inquiryList: data });
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Purchase Inquiry Outward",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: this.state.idUser,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idPurchaseInquiryOutward", "sR.No"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Purchase Inquiry Outward");
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = { id: id, formname: formname, allowToRateVisible: 1 }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({ table2Data: dynamicData, table2ColDefs: dynamicColDefs, isTable2Expanded: true });
                    }
                }
            });
        }
    }

    handleCellClick = (event) => {
        let data = this.state.inquiryObject;
        data.idPurchaseInquiryOutward = event.data[this.state.colName];
        this.setState({ inquiryObject: data });
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Purchase Inquiry Outward");
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    setMainTab = (tab) => {
        this.setState({ activeMainTab: tab }, () => {
            if (tab === 'items' && this.state.itemMasterList.length === 0) {
                this.getItemListForOutward();
            }
        });
    };

    openPopUpForAddingItem = () => {
        // if (!this.state.permissions.isAddEdit) {
        //     this.SwalServices.Error(permission.add);
        //     return;
        // }
        this.transactionStockServices.usp_Transaction_PurchaseInquiryOutwardCount(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let count = response.responseItem.responseContent[0].totalCount + 1
                let formatted = '';
                if (count.toString().length === 1) {
                    formatted = '00' + count;
                } else if (count.toString().length === 2) {
                    formatted = '0' + count;
                } else {
                    formatted = count.toString();
                }
                let inquiryObject = this.state.inquiryObject
                inquiryObject.inquiryOutwardNo = formatted
                inquiryObject.inquiryOutwardDate = moment(new Date()).format('YYYY-MM-DD');
                this.setState({ inquiryObject: inquiryObject }, () => {
                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        this.getItemListForOutward();
                    })
                })
            }
        });
    };

    onRowDoubleClicked = (event) => {
        // if (!this.state.permissions.isAddEdit) {
        //     this.SwalServices.Error(permission.edit);
        //     return;
        // }
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState });
        this.getItemListForOutward();
        this.getPurchaseInquiryOutwardSelectbyId(event.data[this.state.colName]);
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            }
            return {};
        });
    };

    isValidAllFieldsForRegister = () => {
        const newValidState = isValidForm(this.state.inquiryObject, this.state.validationRulesForPurchase, this.state.validState);
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsForItem = () => {
        const newValidState = isValidForm(this.state.itemObject, this.state.validationRulesForItem, this.state.validState);
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false });
    };

    handleChangeForPurchase = (event, name) => {
        let value = event.target.value;
        let details = this.state.inquiryObject;
        details[name] = value;
        this.setState({ inquiryObject: details });
    }

    handleApproveChange = (event) => {
        let details = this.state.inquiryObject;
        details.isApprove = event.target.checked;
        this.setState({ inquiryObject: details });
    }

    handleChangeForItem = (event, name) => {
        let value = event.target.value;
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details });
    }

    handleChangeForDropdown = (event, name, field) => {
        let value = event.value;
        if (field === 'itemObject') {
            let details = this.state.itemObject;
            details[name] = value;
            this.setState({ itemObject: details });
        }
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let details = this.state.inquiryObject;
        details.idPurchaseInquiryOutward = 0;
        details.updateStatus = 0;
        details.idEmployee = 0;
        details.idItem = 0;
        details.itemName = '';
        details.availableQty = 0;
        details.isApprove = false;
        details.remarks = '';
        details.inquiryOutwardDate = moment(new Date()).format('YYYY-MM-DD');
        this.setState({ validState: validState, inquiryObject: details, itemRowData: [] }, () => {
            this.resetitemObject();
        });
    }

    handleOnClick = (event, name) => {
        if (name === "selectItem") {
            this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
        } else if (name === "inquiryDetails") {
            if (!(this.state.inquiryObject.idItem > 0)) {
                this.SwalServices.Error("Please select item first.");
                return;
            }
            this.getInquiriesByItem();
            this.setState({ isSelectInquiryPopUp: !this.state.isSelectInquiryPopUp });
        }
    }

    setOpenModelItem = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };
    setOpenModelInquiry = () => {
        this.setState({ isSelectInquiryPopUp: !this.state.isSelectInquiryPopUp });
    };

    handleItemCellClick = (event) => {
        let data = this.state.inquiryObject;
        data.idItem = event.data.idItem;
        data.itemName = event.data.itemName;
        data.availableQty = event.data.availableQty !== undefined ? event.data.availableQty : 0;
        this.setState({ inquiryObject: data, isSelectItemPopUp: false, itemRowData: [] }, () => {
            this.resetitemObject();
        });
    };

    handleInquiryCellClick = (event) => {
        let data = this.state.itemObject;
        data.idItem = event.data.idItem;
        data.itemName = event.data.itemName;
        data.drawingNo = event.data.drawingNo || "";
        data.materialType = event.data.itemType || "";
        data.idType = this.state.itemObject.TypeList?.find(t => t.label === event.data.itemType)?.value || data.idType;
        data.idPurchaseInquiry = event.data.idPurchaseInquiry;
        data.idPurchaseInquiryItems = event.data.idPurchaseInquiryItems;
        data.inquiryNo = event.data.inquiryNo || "";
        data.pendingQty = event.data.pendingQty;
        data.quantity = event.data.pendingQty;
        this.setState({ itemObject: data, isSelectInquiryPopUp: false });
    };

    insert = (flag) => {
        let isValid = this.isValidAllFieldsForItem();
        if (!isValid) {
            this.SwalServices.Error("Please fill all required fields.");
            return;
        }
        // Available-qty checks apply to new entries only (on edit, availableQty isn't loaded)
        if (this.state.inquiryObject.updateStatus !== 1) {
            if (Number(this.state.inquiryObject.availableQty) <= 0) {
                this.SwalServices.Error("No purchased material available for this item, cannot outward.");
                return;
            }
        }
        let details = this.state.itemObject;
        if (Number(details.quantity) > Number(details.pendingQty)) {
            this.SwalServices.Error("Quantity cannot be greater than pending quantity.");
            return;
        }
        // Total outward quantity (across all rows) cannot exceed the available qty (new entries only)
        if (this.state.inquiryObject.updateStatus !== 1) {
            let available = Number(this.state.inquiryObject.availableQty);
            let usedQty = this.state.itemRowData.reduce((sum, x) => sum + Number(x.quantity || 0), 0);
            if (flag === 'Update') {
                let existing = this.state.itemRowData[details.keyId - 1];
                usedQty -= Number(existing?.quantity || 0);
            }
            if (usedQty + Number(details.quantity) > available) {
                this.SwalServices.Error(`Total quantity cannot exceed available quantity (${available}).`);
                return;
            }
        }
        if (flag === 'Insert') {
            let array = this.state.itemRowData;
            const isItemExists = array.some(x => x.idPurchaseInquiryItems === details.idPurchaseInquiryItems);
            if (isItemExists) {
                this.SwalServices.Error("This inquiry item is already added.");
                return;
            }
            let itemList = [...this.state.itemRowData];
            let obj = {
                drawingNo: details.drawingNo,
                idType: details.idType,
                materialType: details.materialType ? details.materialType : details.TypeList.find(x => x.value === details.idType)?.label,
                idItem: details.idItem,
                itemName: details.itemName,
                quantity: Number(details.quantity),
                remarks: details.remarks,
                idPurchaseInquiry: details.idPurchaseInquiry,
                idPurchaseInquiryItems: details.idPurchaseInquiryItems,
                pendingQty: details.pendingQty,
                inquiryNo: details.inquiryNo,
            }
            itemList.push(obj);
            itemList.map((x, key) => { x.keyId = key + 1; });
            this.setState({ itemRowData: itemList }, () => { this.resetitemObject(); });
        }
        else if (flag === 'Update') {
            let itemList2 = [...this.state.itemRowData];
            itemList2[details.keyId - 1] = {
                ...itemList2[details.keyId - 1],
                drawingNo: details.drawingNo,
                idType: details.idType,
                materialType: details.materialType ? details.materialType : details.TypeList.find(x => x.value === details.idType)?.label,
                idItem: details.idItem,
                itemName: details.itemName,
                quantity: Number(details.quantity),
                remarks: details.remarks,
            };
            itemList2.map((x, key) => { x.keyId = key + 1; });
            this.setState({ itemRowData: itemList2 }, () => { this.resetitemObject(); });
        }
    }

    resetitemObject = () => {
        this.setState({
            itemObject: {
                keyId: 0,
                drawingNo: '',
                idType: 1,
                TypeList: this.state.itemObject.TypeList,
                idItem: 0,
                itemName: '',
                quantity: '',
                remarks: '',
                idPurchaseInquiry: 0,
                idPurchaseInquiryItems: 0,
                materialType: '',
                pendingQty: 0,
                inquiryNo: '',
            }
        });
    }

    onItemRowDataClicked = (event) => {
        let getItemData = this.state.itemRowData[event.data.keyId - 1];
        let details = this.state.itemObject;
        details.keyId = getItemData.keyId;
        details.drawingNo = getItemData.drawingNo;
        details.idType = getItemData.idType;
        details.materialType = getItemData.materialType;
        details.idItem = getItemData.idItem;
        details.itemName = getItemData.itemName;
        details.quantity = getItemData.quantity;
        details.remarks = getItemData.remarks;
        details.idPurchaseInquiry = getItemData.idPurchaseInquiry;
        details.idPurchaseInquiryItems = getItemData.idPurchaseInquiryItems;
        details.pendingQty = getItemData.pendingQty;
        details.inquiryNo = getItemData.inquiryNo;
        this.setState({ itemObject: details });
    };

    submit = () => {
        if (this.isSubmitting) {
            return;
        }
        const isValidAllFieldsForRegister = this.isValidAllFieldsForRegister();
        if (isValidAllFieldsForRegister) {
            if (this.state.itemRowData.length === 0) {
                this.SwalServices.Alert("Please add item details");
            } else if (this.state.inquiryObject.updateStatus !== 1 && this.state.itemRowData.reduce((s, x) => s + Number(x.quantity || 0), 0) > Number(this.state.inquiryObject.availableQty)) {
                this.SwalServices.Error(`Total quantity cannot exceed available quantity (${this.state.inquiryObject.availableQty}).`);
            } else {
                let data = this.state.inquiryObject;
                let itemObject = this.state.itemObject;
                let request = {
                    idPurchaseInquiryOutward: data.idPurchaseInquiryOutward,
                    updateStatus: data.updateStatus,
                    inquiryOutwardNo: data.inquiryOutwardNo,
                    inquiryOutwardDate: data.inquiryOutwardDate && data.inquiryOutwardDate !== 'Invalid date' ? data.inquiryOutwardDate : null,
                    idEmployee: data.idEmployee,
                    idItem: data.idItem,
                    isApprove: data.isApprove ? true : false,
                    remarks: data.remarks ? data.remarks : "",
                    idCompany: this.state.idCompany,
                    prefix: data.prefix,
                    e_Date: data.e_Date ? moment(data.e_Date).format('YYYY-MM-DD') : new Date().toISOString(),
                    e_IDUser: data.updateStatus === 1 ? this.state.idUser : 0,
                    isUpdated: data.updateStatus === 1 ? true : false,
                    updatedDate: data.updateStatus === 1 ? moment(new Date().toISOString()).format('YYYY-MM-DD') : null,
                    u_IDUser: data.updateStatus === 1 ? this.state.idUser : 0,
                    isDeleted: false,
                    deletedDate: null,
                    d_IDUser: 0,
                };
                request.itemList = [];
                this.state.itemRowData.map((details) => {
                    request.itemList.push({
                        idPurchaseInquiry: details.idPurchaseInquiry,
                        idPurchaseInquiryItems: details.idPurchaseInquiryItems,
                        drawingNo: details.drawingNo,
                        itemType: details.materialType ? details.materialType : itemObject.TypeList.find(x => x.value === details.idType)?.label,
                        idItem: details.idItem,
                        quantity: details.quantity,
                        itemRemarks: details.remarks,
                    });
                });
                this.isSubmitting = true;
                this.setState({ isSaving: true });
                this.transactionStockServices.submitPurchaseInquiryOutward(request).then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let res = response.responseItem.responseContent;
                        if (res !== null) {
                            if (this.state.inquiryObject.updateStatus === 1) {
                                this.SwalServices.Success("Updated sucessfully.");
                            } else {
                                this.SwalServices.Success("Save sucessfully.");
                            }
                            this.setState({ isModalOpen: false }, () => {
                                this.resetDetailsFields();
                                this.procSelectAllRecordsSP();
                            });
                        }
                    }
                }).finally(() => {
                    this.isSubmitting = false;
                    this.setState({ isSaving: false });
                });
            }
        }
    }

    deleteItem = (keyId) => {
        let filterData = this.state.itemRowData?.filter(item => item.keyId !== keyId);
        if (filterData.length > 0) {
            filterData.map((x, key) => { x.keyId = key + 1; });
        }
        this.setState({ itemRowData: filterData }, () => { this.resetitemObject(); });
    }

    getPurchaseInquiryOutwardSelectbyId = (idPurchaseInquiryOutward) => {
        if (idPurchaseInquiryOutward > 0) {
            this.transactionStockServices.usp_Transaction_PurchaseInquiryOutwardSelectbyId(idPurchaseInquiryOutward).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let itemListRecords = response.responseItem.responseContent[1];
                    let itemList = [];
                    let inquiryObject = this.state.inquiryObject;
                    inquiryObject.idPurchaseInquiryOutward = res.idPurchaseInquiryOutward;
                    inquiryObject.updateStatus = 1;
                    inquiryObject.inquiryOutwardNo = res.inquiryOutwardNo;
                    inquiryObject.inquiryOutwardDate = res.inquiryOutwardDate ? moment(res.inquiryOutwardDate).format('YYYY-MM-DD') : null;
                    inquiryObject.idItem = res.idItem ? res.idItem : 0;
                    inquiryObject.itemName = res.itemName ? res.itemName : '';
                    inquiryObject.availableQty = res.availableQty !== undefined && res.availableQty !== null ? res.availableQty : 0;
                    inquiryObject.isApprove = res.isApprove ? true : false;
                    inquiryObject.idEmployee = res.idEmployee ? res.idEmployee : 0;
                    inquiryObject.e_Date = res.e_Date;
                    inquiryObject.prefix = res.prefix ? res.prefix : '';
                    inquiryObject.remarks = res.remarks ? res.remarks : '';

                    itemListRecords.map((details, keyId) => {
                        itemList.push({
                            keyId: keyId + 1,
                            idPurchaseInquiryOutwardItems: details.idPurchaseInquiryOutwardItems,
                            idPurchaseInquiry: details.idPurchaseInquiry,
                            idPurchaseInquiryItems: details.idPurchaseInquiryItems,
                            drawingNo: details.drawingNo,
                            idType: this.state.itemObject.TypeList?.find(x => x.label === details.itemType)?.value || "",
                            materialType: details.itemType ? details.itemType : "",
                            idItem: details.idItem ? details.idItem : 0,
                            itemName: details.itemName ? details.itemName : "",
                            quantity: details.quantity ? details.quantity : 0,
                            remarks: details.itemRemarks,
                            pendingQty: details.pendingQty ? details.pendingQty : 0,
                            inquiryNo: details.inquiryNo ? details.inquiryNo : "",
                        });
                    })
                    this.setState({ inquiryObject: inquiryObject, itemRowData: itemList, isModalOpen: true });
                }
            });
        }
    }

    render() {
        return (
            <div className='purchase-inquiry'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <PurchaseInquiryOutwardPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            inquiryObject={this.state.inquiryObject}
                            itemObject={this.state.itemObject}
                            handleChangeForPurchase={this.handleChangeForPurchase.bind(this)}
                            handleApproveChange={this.handleApproveChange.bind(this)}
                            handleChangeForItem={this.handleChangeForItem.bind(this)}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            handleOnClick={this.handleOnClick.bind(this)}
                            insert={this.insert.bind(this)}
                            onItemRowDataClicked={this.onItemRowDataClicked.bind(this)}
                            clearItemObject={this.resetitemObject.bind(this)}
                            delete={this.deleteItem.bind(this)}
                            usp_Users={this.state.usp_Users}
                            globalUserID={this.state.globalUserID}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="tabs flex gap-1 mb-2.5">
                                    <button
                                        type="button"
                                        className={`px-[16px] py-[6px] text-[14px] font-semibold rounded-t-[6px] border border-b-0 cursor-pointer ${this.state.activeMainTab === 'outward' ? 'bg-blue text-white border-blue' : 'bg-slate-100 text-slate-600 border-slate-200'}`}
                                        onClick={() => this.setMainTab('outward')}
                                    >
                                        Purchase inquiry outward
                                    </button>
                                    <button
                                        type="button"
                                        className={`px-[16px] py-[6px] text-[14px] font-semibold rounded-t-[6px] border border-b-0 cursor-pointer ${this.state.activeMainTab === 'items' ? 'bg-blue text-white border-blue' : 'bg-slate-100 text-slate-600 border-slate-200'}`}
                                        onClick={() => this.setMainTab('items')}
                                    >
                                        Items overview
                                    </button>
                                </div>
                                {this.state.activeMainTab === 'outward' ?
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.colDefs}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        onGridReady={this.onGridReady}
                                        onCellClicked={this.handleCellClick}
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    />
                                    :
                                    <AgGridReact
                                        rowData={this.state.itemMasterList}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.itemsOverviewColDefs}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    />
                                }
                            </div>
                        </div>
                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.itemMasterList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModelItem.bind(this)}
                    handleSelectChange={this.handleItemCellClick}
                />
                <SelectItemListPopUp
                    modalName={"Select Inquiry"}
                    selectItemList={this.state.inquiryList}
                    colDefs={this.state.selectInquiryColDefs}
                    isModalOpen={this.state.isSelectInquiryPopUp}
                    setOpenModel={this.setOpenModelInquiry.bind(this)}
                    handleSelectChange={this.handleInquiryCellClick}
                />
            </div>
        )
    }
}
